export default __webpack_public_path__ + "static/media/bill.fbfb3be9.png";